import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type ApiResponseError, fetchApiWithToken } from '~/api/utils'
import { ToastType } from '~/components/Global/Interactions/Toast/ToastType'
import { toast } from '~/utils'
import type { Invoice, InvoiceDto } from '../types'
import { getInvoiceErrorMessage } from '../utils/invoiceErrorMessage'

export const useCreateInvoiceMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<Invoice, ApiResponseError, InvoiceDto>({
    mutationFn: async (payload) => {
      return fetchApiWithToken<Invoice>({
        method: 'post',
        url: '/v1/invoices',
        data: payload
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['invoices'] })
      toast(
        'Facture créée',
        'La facture a été créée avec succès',
        ToastType.Success
      )
    },
    onError: (error) => {
      toast(
        'Erreur lors de la création',
        getInvoiceErrorMessage(
          error,
          'Une erreur est survenue lors de la création de la facture'
        ),
        ToastType.Danger
      )
    }
  })
}
